module.exports = __webpack_public_path__ + "img/nuvia.45eba260.svg";